export const CartLineDetailsTaxMixin = {
    props: {
        /**
         * @type {CartLine}
         */
        cartLine: {
            type: Object,
            required: true,
        },

        /**
         * @type {String}
         */
        cancelLabel: {
            type: String,
            default: 'CANCEL',
        },
    },
};
